import { Vector3 } from "three";
import { canvasRatioToCameraPosition, zoomToCanvasRatio } from "../utils/math3d";
import { getSphericalCoordsFromPositionTarget } from '../utils/getSphericalCoordsFromPositionTarget';
import { getCameraZoomVerticalHorizontal } from '../utils/getCameraZoomVerticalHorizontal';
import getPositionV3FromSphericalCoords from "./getPositionV3FromSphericalCoords";

export const getCameraProps = ({refCamera, refModel, modelHalfHeight, vFovDeg, cameraVerticalAngle, cameraHorizontalAngle, cameraZoom}) => {
    const cameraTargetPositionV3 = new Vector3(0, modelHalfHeight, 0);
    const cameraDistanceDefault = 5;
    let cameraPositionV3 = getPositionV3FromSphericalCoords(cameraDistanceDefault, cameraVerticalAngle, cameraHorizontalAngle);
    cameraPositionV3.y += modelHalfHeight;
    const canvasRatio = zoomToCanvasRatio(cameraZoom);
  
    // In case we don't want to use refCamera
    // const size = useThree(({ size }) => size)
    // const aspect = size.width/size.height;
    if (refCamera?.current && ((refModel.current?.children?.length ?? 0) > 0)) {
      // refCamera.current.updateWorldMatrix(true, false);
      const aspect = refCamera.current.aspect;
      cameraPositionV3 = canvasRatioToCameraPosition({
        aspect,
        root: refModel.current,
        initCameraPositionV3: cameraPositionV3,
        cameraTargetPositionV3,
        vFovDeg,
        canvasRatio,
      });
    }
    
    const cameraUserData = {
        // Deprecated: use cameraTargetPositionV3 instead of fitData.centre
        fitData:{
          center: cameraTargetPositionV3,
        },
    
        getPositionV3FromSphericalCoords,
        getSphericalCoordsFromPositionTarget,
        getCameraZoomVerticalHorizontal,
        modelRoot: refModel.current,
        cameraTargetPositionV3,
        cameraInitPositionV3: cameraPositionV3,
        vFovDeg,
      }
  
    return {
      cameraPositionV3,
      cameraUserData,
    }
  }
  